//#region src/utils/redux/action-utils.ts
var lifeCycle = {
	FULFILLED: "fulfilled",
	PENDING: "pending",
	REJECTED: "rejected"
};
var isRequestStatus = (action, matcher = "", status) => {
	return action?.type?.startsWith(matcher) && action?.meta?.requestStatus === status;
};
var isFulfilled = (action, matcher = "", excludeTypes = []) => {
	if (excludeTypes.some((type) => action?.type?.startsWith(type))) return false;
	return isRequestStatus(action, matcher, lifeCycle.FULFILLED);
};
var isPending = (action, matcher = "", excludeTypes = []) => {
	if (action?.type?.includes("track") || excludeTypes.some((type) => action?.type?.startsWith(type))) return false;
	return isRequestStatus(action, matcher, lifeCycle.PENDING);
};
var isRejected = (action, matcher = "", excludeTypes = []) => {
	if (excludeTypes.some((type) => action?.type?.startsWith(type))) return false;
	return isRequestStatus(action, matcher, lifeCycle.REJECTED);
};
//#endregion
export { isFulfilled, isPending, isRejected, lifeCycle };

//# sourceMappingURL=action-utils.js.map